module.exports = __webpack_public_path__ + "img/p2-80.d2443b5f.png";